module.exports = __webpack_public_path__ + "static/rocket_exploration-0da57ab0b5355c63a3ee2691af04d2f6.svg";